import { Fragment, ReactElement, useMemo } from 'react';
import { useActionAuthorization } from 'shell/hooks/use-action-authorization';
import TableAdministrationCollapse from './table-administration-collapse';
import GeographicCollapse from './geographic-collapse';
import EventManagerCollapse from './event-manager-collapse';
import { useRouteAuthorization } from 'shell/hooks/use-route-authorization';
import { systemRoutes } from 'system/router/routing-config';
import { ClassNameMap, ListItem, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';
import { useStyles } from '../collapse-item';
import { DisabledMenuAuthorization } from 'system/pages/home';
import { AuthorizationSystemMenu } from 'shell/components/navbar/collapse-item';
import BatchManagementCollapse from './batch-management-collapse';

interface NestedItemsSystemProps {
  link: string;
  onSubItemClick?: () => void;
}

const NestedItemsSystem = ({ link, onSubItemClick }: NestedItemsSystemProps): ReactElement => {
  const items =
    useRouteAuthorization(systemRoutes[0].children[0].children)?.filter((route) => !route.hidden) ||
    [];

  const classes: ClassNameMap<string> = useStyles();

  // Menu profile and group active elements
  const visibility = useActionAuthorization<DisabledMenuAuthorization>(AuthorizationSystemMenu);

  const visibilityGeographic = useMemo(() => {
    return (
      !visibility.municipality &&
      !visibility.region &&
      !visibility.province &&
      !visibility.state &&
      !visibility.territory &&
      !visibility.consulate
    );
  }, [visibility]);

  const visibilityEventManager = useMemo(() => {
    return (
      !visibility.eventType &&
      !visibility.eventRegistration &&
      !visibility.searchEventsInError &&
      !visibility.destinationType &&
      !visibility.subscriber &&
      !visibility.searchPublishedEvents &&
      !visibility.managementNonRecoverableErrors
    );
  }, [visibility]);

  return (
    <Fragment>
      {!visibility.group && !visibility.profile && (items?.length || 0) === 0 ? undefined : (
        <TableAdministrationCollapse
          link={link}
          onSubItemClick={onSubItemClick}
          active={visibility}
        />
      )}
      {visibilityGeographic ? undefined : (
        <GeographicCollapse link={link} onSubItemClick={onSubItemClick} active={visibility} />
      )}
      {visibilityEventManager ? undefined : (
        <EventManagerCollapse link={link} onSubItemClick={onSubItemClick} />
      )}
      <BatchManagementCollapse link={link} onSubItemClick={onSubItemClick} />
      {!visibility.toponymy ? undefined : (
        <Link key={`${link}/toponomastica`} to={`${link}/toponomastica`} className="pmi-anchor">
          <ListItem
            button
            key={`${link}/toponomastica`}
            onClick={onSubItemClick}
            className={classes.nested}
          >
            <ListItemText className={classes.colorItems} primary="Tabelle Toponomastica" />
          </ListItem>
        </Link>
      )}
    </Fragment>
  );
};

NestedItemsSystem.displayName = 'nested Items system component';

export default NestedItemsSystem;
